// extracted by mini-css-extract-plugin
export default {"invoicesTable":"Pi63HHpMhzQJeVjSM2Kr"};